import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getAll: {
    queryFn: () => useApi().routes.getAllRoutes(),
    queryKey: () => ['allRoutes']
  },
  getAllBySite: {
    queryFn: (args: Ref<{ siteId?: number }>) => useApi().routes.getAllRoutes(args.value.siteId),
    queryKey: (args: Ref<{ siteId?: number }>) => ['allRoutes', { siteId: args.value.siteId }]
  },
  getHierarchy: {
    queryFn: () => useApi().routes.getRoutesHierarchy(),
    queryKey: () => ['routesHierarchy']
  },
  getHierarchyBySite: {
    queryFn: (args: Ref<{ siteId?: number }>) => useApi().routes.getRoutesHierarchy(args.value.siteId),
    queryKey: (args: Ref<{ siteId?: number }>) => ['routesHierarchy', { siteId: args.value.siteId }]
  }
} as const

const mutations = {
  // Mutations for creating, updating, and deleting routes
} as const

export type RouteService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): RouteService =>
  defineService(authArgs, {
    queries,
    mutations
  })
